@use '@dixa/lib-shared-tokens/scss' as *;

$hovered: null;
$favorite: null;

.item {
  &Hovered {
    $hovered: & !global;
  }

  &Favorite {
    $favorite: & !global;
  }
}

.iconButtons {
  display: flex;
}

.favoriteButton {
  margin: minus(var(--dixa-size-spacer-200)) 0;
  opacity: 0;
  transition: opacity ease-in 150ms;

  #{$hovered} &,
  #{$favorite} & {
    opacity: 1;
  }

  svg {
    transition: transform 200ms;
  }

  &:hover svg {
    transform: scale(1.2);
  }
}

.templateName {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  min-width: 0;
  flex: 1;
}

.textContainer {
  min-width: 0;
  flex: 1;
  overflow: hidden;
}

.previewButton {
  margin: minus(var(--dixa-size-spacer-200)) 0;
  opacity: 0;
  transition: opacity ease-in 150ms;

  #{$hovered} & {
    opacity: 1;
  }

  &:hover svg {
    transform: scale(1.2);
  }
}
